<template>
  <div>
    <div class="sayfahead">
      <h1>{{ SayfaAdi }}</h1>
      <div class="float-right BankaSecim">
        <el-select v-model="Banka_id" size="small" @change="SayfaYukle" placeholder="Banka Hesabı Seçiniz" filterable
                   clearable>
          <el-option
            v-for="item in BankaListe"
            :key="item.id"
            :label="item.Tanim"
            :value="item.id">
            <span style="float: left">{{ item.Tanim }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Banka }}</span>
          </el-option>
        </el-select>
      </div>
      <el-button-group class="float-right YeniBtn">
        <el-button @click="Excel()" type="primary" size="small">Excel Yükle</el-button>
        <el-button @click="Manuel()" type="warning" size="small">Manuel Kontrol</el-button>
      </el-button-group>
    </div>
    <div class="icerik" :style="'height:'+Height+'px'">
      <Yukleniyor :data="lo"></Yukleniyor>
      <table class="table table-hover">
        <thead>
        <tr>
          <th width="5%">Banka</th>
          <th width="5%">Tür</th>
          <th width="20%">Referans No</th>
          <th width="10%">İşlem Tarihi</th>
          <th width="50%">Açıklama</th>
          <th class="text-right" width="10%">Bakiye</th>
          <th class="text-right" width="10%">Tutar</th>
          <th class="text-right" width="10%">Kalan</th>
          <th class="text-right" width="50%">İşlem</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="l in Liste">
          <td><img :src="'https://pos.mudu.pro/oi/banka/'+l.Banka+'.png'" width="50"></td>
          <td>{{ l.Tur }}</td>
          <td>{{ l.Referans }}</td>
          <td>{{ l.iTarihi }}</td>
          <td>{{ l.Aciklama }}</td>
          <td class="text-right"><b>{{ l.BakiyeText }}</b><sup>TL</sup></td>
          <td class="text-right"><b>{{ l.TutarText }}</b><sup>TL</sup></td>
          <td class="text-right"><b>{{ l.KalanText }}</b><sup>TL</sup></td>
          <td class="text-right">
            <el-popover
              placement="left"
              width="400"
              v-model="l.Islem">
              <div class="p-2">
                <p><b>Hareketi Mahsuplaştır</b> <a class="float-right text-kirmizi" @click="l.Islem = false"><i
                  class="el-icon-close"></i></a></p>
                <small><b class="text-mavi">{{ l.TutarText }}<sup>TL</sup></b> {{ l.Aciklama }} </small>
                <div style="margin: 10px 0">
                  <el-select
                    size="mini"
                    v-model="l.Ilgili_id"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    :placeholder="l.Tur==='Gelen'?'Borçlu Ad Soyad Yazınız':'Ünvan Yazınız'"
                    :remote-method="data => remoteMethod(l,data)"
                    :loading="loading">
                    <el-option
                      v-if="l.Tur==='Gelen'"
                      v-for="item in Kisiler"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }} <sup>{{ item.Tutar }}TL</sup></span>
                      <span
                        style="float: right; color: #8492a6; font-size: 12px">{{ item.Bina }} - {{
                          item.kNo
                        }} No.</span>
                    </el-option>
                    <el-option
                      v-if="l.Tur==='Giden'"
                      v-for="item in Cariler"
                      :key="item.id"
                      :label="item.Unvan"
                      :value="item.id">
                      <span style="float: left">{{ item.Unvan }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 12px">{{ item.vNo }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" class="text-sari pull-left" type="text danger" @click="Yoksay(l.id)">Yoksay
                  </el-button>
                  <el-button type="primary" size="mini" :disabled="!l.Ilgili_id" @click="MakbuzUret(l)">Makbuz Üret
                  </el-button>
                </div>
              </div>
              <i slot="reference" :class="l.Tur==='Gelen'?'text-success':'text-danger'"
                 class="tableibtn feather-cast"></i>
            </el-popover>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
    <el-dialog
      v-if="TahsilatModal"
      :title="ModalAdi"
      :visible.sync="TahsilatModal"
      fullscreen
      append-to-body
      :before-close="SayfaYukle">
      <a @click="SayfaYukle" class="ModalKapat"><i class="el-icon-close"></i></a>
      <VezneKisiTahsilat :BankaEkstre="BankaEkstre" @SayfaAdi="SayfaAdiGetir($event)" @Yenile="KisiGetir($event)"
                         :Kisi_id="Kisi_id"
                         v-if="Kisi_id"></VezneKisiTahsilat>
    </el-dialog>

    <OdemeIsle :OdemeIsleModal="OdemeIsleModal" @OdemeIsleModal="SayfaYukle()" v-if="Cari_id"
               :BankaEkstre="BankaEkstre" :Bina_id="null"
               :Cari_id="Cari_id"></OdemeIsle>
    <ExcelBankaEkstre :ExcelModal="ExcelModal" @ExcelModal="SayfaYukle"></ExcelBankaEkstre>
  </div>
</template>

<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";
import VezneKisiTahsilat from "../../components/Pack/Vezne/VezneKisiTahsilat";
import OdemeIsle from "../../components/Pack/Muhasebe/cari/OdemeIsle";
import ExcelBankaEkstre from "../../components/Pack/Vezne/ExcelBankaEkstre";

export default {
  components: {ExcelBankaEkstre, OdemeIsle, VezneKisiTahsilat, Yukleniyor},
  data() {
    return {
      AramaKey: null,
      ExcelModal: false,
      OdemeIsleModal: false,
      Banka_id: null,
      Kisiler: null,
      Cariler: null,
      SayfaAdi: 'Banka Hesapları',
      Liste: null,
      loading: false,
      lo: false,
      TahsilatModal: false,
      ModalAdi: null,
      Kisi_id: null,
      Cari_id: null,
      Secilen: null,
      BankaEkstre: null,
      BankaListe: [],
      Height: window.innerHeight - 140
    }
  },
  methods: {
    remoteMethod(k, query) {
      // console.log(query);
      if (query !== '') {
        this.loading = true;
        this.$store.dispatch("Post", {
          Kelime: query,
          Bina_id: k.Bina_id,
          path: 'spesiyal/spotlight'
        })
          .then(response => {
            this.loading = false;
            this.Kisiler = response.Kisi;
            this.Cariler = response.Cari;
          })


      } else {
        this.loading = false;
        this.Kisiler = [];
        this.Cariler = [];
      }
    },
    SayfaAdiGetir(event) {
      this.ModalAdi = event
    },
    KisiGetir(event) {
      //console.log(event)
    },
    SayfaYukle() {
      this.ExcelModal = false;
      this.TahsilatModal = false;
      this.ModalAdi = null;
      this.Kisi_id = null;
      this.Cari_id = null;
      this.BankaEkstre = null;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'entegrasyon/ekstre/' + this.Banka_id})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
    MakbuzUret(Bilgi) {
      this.BankaEkstre = Bilgi;
      this.Kisi_id = null;
      this.Cari_id = null;
      if (this.BankaEkstre.Tur === 'Gelen') {
        this.Kisi_id = this.BankaEkstre.Ilgili_id;
        this.ModalAdi = "Banka Tahsilat";
        this.TahsilatModal = true;
        this.OdemeIsleModal = false;
      } else {
        this.Cari_id = this.BankaEkstre.Ilgili_id;
        this.ModalAdi = "Banka Ödeme";
        this.TahsilatModal = false;
        this.OdemeIsleModal = true;
      }

    },
    Excel() {
      this.ExcelModal = true;
    },
    Yoksay(id) {
      this.lo = true;
      this.loading = true;
      this.$store.dispatch("Put", {
        id: id,
        path: 'entegrasyon/ekstre'
      })
        .then(response => {
          this.lo = false;
          this.SayfaYukle();
        })
    },
    Manuel() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'spesiyal/bankakontrol/'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.SayfaYukle();
            if (response.Hareket > 0)
              this.$message.success(response.Banka + " bankadan toplam " + response.Hareket + " yeni hareket işlendi.");
            else
              this.$message.success(response.Banka + " bankada yeni hareket yok.");

          }
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.$store.dispatch("Get", {path: 'entegrasyon/banka/'})
      .then(response => {
        this.lo = false;
        if (response.Durum === 'OK') {
          this.BankaListe = response.Liste
        }
      });
  },
  computed: {
    KisiSecim() {
      return this.BankaEkstre
    },
  },
  watch: {
    KisiSecim() {
      if (this.BankaEkstre.Tur === 'Gelen') {
        this.Cari_id = null;
        this.Kisi_id = this.BankaEkstre.Ilgili_id;
      } else {
        this.Kisi_id = null;
        this.Cari_id = this.BankaEkstre.Ilgili_id;
      }
      //console.log(this.Form.Tutar);
    },
  }

}
</script>
<style scoped>
.BankaSecim {
  display: inline-block;
  position: relative;
  top: -3px;
  right: 218px;
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Vezne/Banka.vue